import LayerSettingsModels from "../../../models/map-data-model-b/layer-setting-models";
export function ConvertColsDataDetailViewToStandardData(
  cols: LayerSettingsModels.LayerSettingsDisplayColModel[]
): any {
  const result: any = {};
  if (!cols?.length) return result;
  cols.map((col) => {
    result[col.col] = col.alias;
  });
  return result;
}
